import type { ProductItemThemeSettings } from '@providers/ThemeProvider/types';

import type { InventoryStatusProps } from '@/features/filter-product-list/product-list/product-item/InventoryStatus';

export type InventoryStatusPropsMapSettings = Omit<InventoryStatusProps, 'inventory'>;

export const useConnectInventoryStatus = (settings: ProductItemThemeSettings) => {
  const productInventoryStatusSettings = settings.productInfo?.elements?.inventoryStatus;

  return {
    props: productInventoryStatusSettings || {},
  };
};
